// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../shared/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../shared/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EditUser_root__Gnh0a {
    margin: 20px 20px;
}

.EditUser_breadcrumb__cbIpD {
    margin-bottom: 20px;
}

.EditUser_label__qucR9 {
    font-size: 14px !important;
    font-weight: 600 !important;
}

.EditUser_formItem__nOnfa {
    margin-bottom: 10px;
}

.EditUser_submitButton__sJvRt, 
.EditUser_backButton__d2lBs,
.EditUser_deleteButton__-vpPr {
    margin-top: 15px;
    width: 100%;
    font-size: 16px;
    min-height: auto;
}

.EditUser_deleteButton__-vpPr {
    color: red;
}

.EditUser_buttonsHolder__bEtE4 {
    & .ant-form-item {
        margin-bottom: 0;
    }
}`, "",{"version":3,"sources":["webpack://./src/views/EditUser/EditUser.module.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,0BAA0B;IAC1B,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;;IAGI,gBAAgB;IAChB,WAAW;IACX,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ","sourcesContent":[".root {\n    margin: 20px 20px;\n}\n\n.breadcrumb {\n    margin-bottom: 20px;\n}\n\n.label {\n    font-size: 14px !important;\n    font-weight: 600 !important;\n}\n\n.formItem {\n    margin-bottom: 10px;\n}\n\n.submitButton, \n.backButton,\n.deleteButton {\n    margin-top: 15px;\n    width: 100%;\n    font-size: 16px;\n    min-height: auto;\n}\n\n.deleteButton {\n    color: red;\n}\n\n.buttonsHolder {\n    & :global(.ant-form-item) {\n        margin-bottom: 0;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `EditUser_root__Gnh0a`,
	"breadcrumb": `EditUser_breadcrumb__cbIpD`,
	"label": `EditUser_label__qucR9`,
	"formItem": `EditUser_formItem__nOnfa`,
	"submitButton": `EditUser_submitButton__sJvRt`,
	"backButton": `EditUser_backButton__d2lBs`,
	"deleteButton": `EditUser_deleteButton__-vpPr`,
	"buttonsHolder": `EditUser_buttonsHolder__bEtE4`
};
export default ___CSS_LOADER_EXPORT___;
